import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { updateMaintenanceServiceOperationHours } from '../../api/maintenance-service.ts';
import { UpdateMaintenanceServiceOperationHoursRequest } from '../../api/requests/maintenance-service-request.ts';

export default function useUpdateMaintenanceServiceOperationHours(): UseMutationResult<
  Awaited<ReturnType<typeof updateMaintenanceServiceOperationHours>>,
  Error,
  UpdateMaintenanceServiceOperationHoursRequest
> {
  return useMutation({
    mutationFn: updateMaintenanceServiceOperationHours,
  });
}
